// extracted by mini-css-extract-plugin
export default {"icon":"ExpandIcon_icon__-Xq+D","expanded":"ExpandIcon_expanded__2kg9C"};